<template>
  <DotLottieVue ref="Service3" class="size-[200px] lg:size-[15vw]" autoplay :src="props.src" />
</template>

<script setup>
const props = defineProps({
  src: {
    type: String,
    default: "",
  },
})

const Service3 = ref();

const initiateInterval = () => {
  setInterval(() => {
    if (Service3.value && import.meta.client) {
      const lottieInstance = Service3.value.getDotLottieInstance()
      lottieInstance.play()
    }
  }, 9300)
}

onMounted(() => {
  nextTick(() => {
    initiateInterval()
  })
})
</script>
